import { Header } from "@src/components"

export default function Collections() {
  return (
    <>
      <Header title="Collections" />
      {/*  */}
    </>
  )
}
